import "../../shared/components/modal.js";

window.IndexTableConfig = function (trigger, tableSettingHeader, tableSettingBody, tableSettingFooter, modalClass) {
  var settingsModal = new WizardModal({
    class: "admin-modal " + (modalClass || ""),
  });

  var page = settingsModal.addPage({
    header: tableSettingHeader,
    body: tableSettingBody,
  });

  // BEHAVIOUR

  jQuery(document).on("click", trigger, function () {
    settingsModal.show();
    page.nav.find('[data-behaviour="close-modal"]').before(tableSettingFooter).hide();
  });

  // Reset the options when the modal is canceled
  jQuery(settingsModal.container).on("cancel", function () {
    page.setBody(tableSettingBody);
  });

  // Submit the changes when we complete the modal
  jQuery(settingsModal.container).on("complete", function () {
    jQuery(settingsModal.container).find("form").trigger("submit");
  });
};
